module.exports = __webpack_public_path__ + "img/nplus.32a9ea87.png";